import { trackAmplitudeEvent } from '../analytics/CustomEvents'

export default function initStyleQuizEntryModal () {
  if (window.location.pathname.startsWith('/purchase')) {
    // arbitrary delay to ensure Amplitude is loaded
    setTimeout(() => trackAmplitudeEvent('Style Quiz Entry Modal Blocked On /Purchase'), 2000)
    return
  }

  const modal = document.getElementById('vjs-stylequiz-entry-modal')
  if (!modal) return

  const closeButtons = document.querySelectorAll('.vjs-stylequiz-entry-modal-close')

  if (!window.localStorage.getItem('styleQuizEntryModalShown')) {
    modal.classList.add('show')
    window.localStorage.setItem('styleQuizEntryModalShown', 'true')
  }

  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      modal.classList.remove('show')
    })
  })
}
